import axios from 'axios';
import { NO_COMPANY_SCOPE_REQUEST_CONFIG } from '../../hooks/dashboard';

/**
 * ROAR-4942 — Login Activity reads.
 *
 * AC9: this endpoint is company-scoped SERVER-SIDE by the P1.10 scope-resolver middleware. The
 * client sends no company identifier at all — not as an argument, not in the query string, and not
 * as a header: `NO_COMPANY_SCOPE_REQUEST_CONFIG` (exported from hooks/dashboard.js by ROAR-4940)
 * deletes the `company_id`/`selected_company_uuid` headers that src/index.js sets at bootstrap.
 *
 * Importing that config pulls in hooks/dashboard.js's ESM-only `query-string` dependency, so any
 * test touching this module needs `jest.mock('query-string', () => ({ stringify: jest.fn() }))`.
 *
 * FIELD NAMES RATIFIED 2026-09-24 (ROAR-4945). The collection is `user_login_histories`, and the
 * wire shape is `{ id, occurred_at, device, location }`.
 *
 * `device` is the wire name but carries `logged_in_using` — the auth METHOD (`'password'`,
 * `'google'`, `'email_code'`, …). The collection stores NO user-agent, so there is no browser or
 * OS here and never was; `components/Settings/LoginActivity` labels it through
 * `utils/constants/loginAuthMethods` and heads the column "SIGNED IN WITH" rather than DEVICE.
 *
 * Request params confirmed against the shipped route: `page` and `page_size` only.
 *
 * @param {object} [params]
 * @param {number} [params.page] 1-based page number.
 * @param {number} [params.pageSize] Rows per page.
 * @returns {Promise<{items: Array<object>, page: number, page_size: number, has_more?: boolean}>}
 */
export const getLoginActivity = async ({ page = 1, pageSize = 25 } = {}) => {
  const res = await axios.get('/account/login-activity', {
    ...NO_COMPANY_SCOPE_REQUEST_CONFIG,
    params: { page, page_size: pageSize },
  });
  return res.data;
};
